module.exports = function() {
  return new Worker(__webpack_public_path__ + "4ed703e930bcbd61774f.worker.js");
};